<template lang="pug">
	div.cat-menu(:class="(activo) ? 'active' : ''", v-if="mostrar")
		div.item-menu(:class="(item.tipo === 'categoria') ? 'categoria' : ''", @click="clica(item)")
			div
				span(:class="item.icono")
			div
				span(:class="(item.items && item.items.length > 0) ? 'font-weight-bold' : ''") {{item.nombre}}
				span.fa.pull-right.mr-2.mt-1(:class="(activo) ? 'fa-caret-down' : 'fa-caret-left'", v-if="item.items && item.items.length > 0")
			div
				span(:class="item.icono")
		menu-item(v-for="it in item.items", :key="it.nombre", :item="it")
</template>

<script>

import MenuItem from './menu-item'

export default {
	name: 'menu-item',

	data: function () {
		return {
			activo: false
		}
	},
	components: {
		'menu-item': MenuItem
	},
	props: ['item'],
	computed: {
		mostrar () {
			if (this.item.tipo === 'categoria' && this.item.items.length === 0) {
				return false
			}
			return true
		}
	},
	methods: {
		clica (item) {
			if (item.path) {
				this.$router.push(item.path)
			} else if (item.items && item.items.length > 0) {
				this.activo = !this.activo
			}
		}
	}
}
</script>

<style scoped>
	.cat-menu {
		position: relative;
		display: block;
		width: 100%;
		max-height: 40px;
		overflow: hidden;
		/*transition: max-height 500ms ease-in-out;*/
	}

	.cat-menu.active {
		max-height: 100%;
	}

	.item-menu {
		position: relative;
		display: table;
		width: 100%;
		height: 40px;
		border-bottom: 1px solid #e0e0e0;
		cursor: pointer;
	}
	.item-menu:hover {
		background-color: #f0f0f0;
		/*color: white;*/
	}

	.categoria {
		background-color: #f0f0f0 !important;
		/* color: white; */
	}

	.categoria > div {
		border: none !important;
	}

	.item-menu div:first-child {
		display: table-cell;
		position: relative;
		width: 40px;
		border-right: 1px solid #e0e0e0;
		vertical-align: middle;
	}

	.item-menu div:nth-child(2) {
		display: table-cell;
		position: relative;
		text-align: left;
		padding-left: 10px;
		vertical-align: middle;
	}
	.item-menu div:nth-child(3) {
		display: none;
	}

	@media (max-width:1500px) {
		.item-menu div:first-child {
			display: none;
		}
		.item-menu div:nth-child(2) {
			display: table-cell;
			position: relative;
			text-align: left;
			padding-left: 10px;
			vertical-align: middle;
		}
		.item-menu div:nth-child(3) {
			display: table-cell;
			position: relative;
			width: 40px;
			border-right: 1px solid #e0e0e0;
			vertical-align: middle;
		}
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/main/menu-item.vue